<div class="container error-dialog-container red">
    <div class="row">
        <span class="k-icon k-i-warning error-dialog-icon"></span>
        <span #errorMessage class="col" [innerHtml]="getTrustedErrorHtml()"></span>
    </div>

    <div class="d-flex flex-row-reverse mt-4">
        <button kendoButton [primary]="true" type="button" (click)="close()">
            Close
        </button>
    </div>
</div>
